// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__yyLhl","content":"RecentSearches_content__3Ea-C"};